<div class="power-bi-report-page">
  <!-- Header Section -->
  <div class="flex ml-72 mr-72 mt-20 items-center justify-between header-section">
    <div class="flex items-center">
      <mat-icon svgIcon="analytics" class="icon-lg mr-4"></mat-icon>
      <div class="mat-subtitle-2 mb-0 fs-24 fw-600 ml-2">{{ 'TENANT_LAYOUT.MENU.EOL_REPORT' | transloco }}</div>
    </div>
    <div class="flex items-center gap-2">
      <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshReport()" matTooltip="Refresh Report" matTooltipPosition="below" matTooltipClass="tooltip-with-arrow">
        <mat-icon svgIcon="refresh" class="icons"></mat-icon>
      </div>
      <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="openInNewTab()" matTooltip="Open in Power BI" matTooltipPosition="below" matTooltipClass="tooltip-with-arrow">
        <mat-icon svgIcon="open_in_new" class="icons"></mat-icon>
      </div>
    </div>
  </div>

  <!-- Divider Line -->
  <mat-divider class="neutral-2 mt-12 ml-72 mr-72"></mat-divider>

  <!-- Report Viewer -->
  <div class="ml-72 mr-72 mt-16">
    <app-power-bi-report-viewer
      #reportViewer
      [height]="reportHeight"
      [showToolbar]="false"
      [showLink]="false"
    ></app-power-bi-report-viewer>
  </div>
</div>
